import React, { Fragment } from "react";
import { ParagraphComponent } from "./ParagraphComponent";
import style from '../scss/Valida.module.scss';
import { useCotizador } from "../context/apiContext";
import { useApplication } from "../context/applicationContext";
import { useQuoteFormContext } from "hooks/useQuoteFormContext";

export const APPLICATION = "application";
export const COTIZADOR = "cotizador";
export const FAV_PLAN = "favPlan";


const ValidaComponent = ({ keyName, dependant = false, benefit = false, styleGroup, phase = COTIZADOR, section = "" }) => {
    // dependant/benefit lookups prefer the route-aware quoteFormErrors (so
    // /fav-plan/* reads its own errors, not the quoter's) and fall back to
    // errors_ (the quoter's own state) only when that's unavailable - this
    // fallback is a no-op on quoter routes, where quoteFormErrors already IS
    // errors_ (useQuoteFormContext resolves to apiContext there).
    const { errors: errors_ } = useCotizador();
    const { errors: errors_app } = useApplication();
    const quoteFormErrors = useQuoteFormContext()?.errors;

    let errors = phase === APPLICATION ? errors_app : quoteFormErrors;
    if (!errors) {
        errors = errors_;
    }
    if (dependant)
        errors = quoteFormErrors?.dependants ?? errors_.dependants ?? errors_;
    if (benefit)
        errors = quoteFormErrors?.benefitsList ?? errors_.benefitsList ?? errors_;

    if (section) {
        errors = errors[section];
    }


    if (errors?.[keyName] === undefined) return;
    const validateExist = () => {
        for (const i of Object.values(errors[keyName])) {
            if (i) {
                return true;
            }
        }
        return false;
    }
    if (!validateExist()) return;
    let values = Object.values(errors[keyName]).filter(i => i);
    values = values.length && [values[0]];
    if (values[0].includes("[hidden]")) return;

    return (
        <Fragment>

            <div className={`${style.requiere} ${styleGroup}`}>
                {values.map((i, index) => (
                    <Fragment key={`error-${index}-${i}`}>
                        <ParagraphComponent styleGroup='mb-0 color-white'>* {i}</ParagraphComponent>
                    </Fragment>
                ))}
            </div>


        </Fragment>
    )
}

export default ValidaComponent;
